// System
import { Box, Typography } from '@mui/material';

// Components
import { UserDrawerDetails } from './UserDrawerDetails';
import { TabDrawerLayout } from '@Components/shared/layouts/TabDrawerLayout';
import { DrawerHeaderLayout } from '@Components/shared/layouts/DrawerHeaderLayout';
import { SaveSettingsButtonPanel } from '@Components/shared/buttons/SaveSettingsButtonPanel';

// Redux
import { useDispatch } from 'react-redux';
import { useUserDrawer } from '@Modal/hooks/users/useUserDrawer';
import { useSetupUserForm } from '@Forms/users/SetupUserFormContext';
import { FormProvider } from 'react-hook-form';
import { SetupUserDrawerFooter } from './SetupUserDrawerFooter';

export const SetupUserDrawerContent: React.FC = () => {
  const { selectedUser, setShowDeleteUserModal, submittable, handleSubmitGeneralForm, handleCreateCancel } = useUserDrawer();
  const methods = useSetupUserForm();
  const dispatch = useDispatch();

  return (
    <TabDrawerLayout
      header={
        <DrawerHeaderLayout currentSlug="/users" onClose={handleCreateCancel}>
          <Box>
            <Typography variant="h6">{selectedUser?.id}</Typography>
          </Box>
        </DrawerHeaderLayout>
      }
      footer={
        <SetupUserDrawerFooter />
      }
    >
      <FormProvider {...methods}>
          <UserDrawerDetails />
      </FormProvider>
    </TabDrawerLayout>
  );
};
